import React, { useEffect, useState } from "react";
import ListItem from "../../component/ListItem";
import { useParams } from "react-router-dom";
// import menuList from "../../sample-data/menu.json"
import Tabs from "../../component/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenuData } from "../../redux/action";
import CartButton from "../../component/CartButton";
import ItemEdit from "../../component/MenuCard/ItemEdit";
import { SectionLoader } from "../../component/common/Loader";
// import LoginPage from "../Login";

const MenuAlter = () => {

    // Todo:
    // Fetch the menu item for the restaurent 
    // Implement the redux 
    // Save the fetched data in local store
    // Call tabs here
    // Pass the value to tabs
    // Pass the value to ListItem
    // 
    const { restaurantId, locationId } = useParams()
    const [selectedTabId, setSelectedTab] = useState('')

    const dispatch = useDispatch();
    const menuList = useSelector((state) => state?.user?.menu);
    const cart = useSelector((state) => state?.user?.cart);
    const user = useSelector((state) => state?.user?.user);
    const guestUser = useSelector((state) => state?.user?.guestUser);
    const [search, setSearch] = useState("");

    useEffect(() => {
        dispatch(fetchMenuData())
    }, [])

    // todo: by default 1st item should be selected [may be we can add isSelected prop later while parting]
    // const tabList = () => menuList?.categories.map((val) => { 
    //     return { categoryId: val.categoryId, category: val.category, isSelected: val.isSelected }
    // });

    const tabList = () => {
        if (!menuList || !menuList.categories) return [];
        return menuList.categories.map((val) => ({ categoryId: val.categoryId, category: val.categoryName, isSelected: val.isSelected }
        ));
    };

    // const selectedItems = () => menuList.categories.filter((val) => val.categoryId === selectedTab)[0].items
    // const selectedItems = () => menuList.categories.filter((val) => val.isSelected === true)[0].items
    // const selectedItems = () => {
    //     const items = menuList.categories.filter((val) => val.isSelected === true)
    //     return items.length !== 0 ? items[0].items : menuList.categories[0].items;
    // }
    // const selectedItems = () => {
    //     // console.log("Menu List: ", menuList, selectedTab);
    //     if (!menuList || !menuList.categories) return [];
    //     else{
    //        const category = menuList.categories.find((val) => val.categoryId === selectedTab)
    //        return category ? category : menuList.categories[0]; 
    //     } 
    // }

    const selectedItems = () => {
        if (!menuList || !menuList.categories) return null;

        // Case 1: category is selected
        const category = menuList.categories.find(
            (cat) => cat.categoryId === selectedTabId
        );

        if (category) {
            return {
                ...category,
                items: (category.items || []).filter((food) =>
                    food?.foodName?.toLowerCase().includes(search.toLowerCase())
                )
            };
        }

        // Case 2: no tab selected yet → first category with items
        const firstCategoryWithItems = menuList.categories.find(cat =>
            Array.isArray(cat.items) && cat.items.length > 0
        );

        if (firstCategoryWithItems) {
            return {
                ...firstCategoryWithItems,
                items: firstCategoryWithItems.items
            };
        }

        return null;
    };

    // return (!(user || guestUser) ? <LoginPage /> : <div className="lrSpace">
    return (<div className="cart-container">
        <div className="lrSpace">
            {/* RestaurantLogo [Clickable - Link to Restaurant Profile] & Name */}
            {/* <div>{restaurantId} & {locationId}</div> */}
            <h2>✏️ Update menu item</h2>
            {/* <CartButton /> */}
            {menuList?.categories?.length > 0 ? (
                <>
                    {/* Tab menu here */}
                    <Tabs tabs={tabList()} tabSelect={setSelectedTab} />
                    {/* filter selected category and shared the menu list, here */}
                    <input type="text" placeholder="Search items in selected category......"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="search-input" />
                    <ListItem category={selectedItems()} ActionComponent={ItemEdit} />
                </>) :
                (<SectionLoader label="Loading menu..." rows={4} />)
            }
        </div>
    </div>)
}

export default MenuAlter;
